import React from 'react';
import Header, { LanguageProvider } from './components/Header';
import Hero from './components/Hero';
import DiseaseDetection from './components/About';
import CropPrediction from './components/Services';
import WeatherInsights from './components/Contact';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <CropPrediction />
        <DiseaseDetection />
        <WeatherInsights />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;